var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 0.16c-212.064 0-384 171.936-384 384 0 64.832 16.224 125.856 44.64 179.456l-267.008 266.944 0.224 0.192c-20.864 20.512-33.856 48.928-33.856 80.512 0 62.368 50.56 112.928 112.928 112.928 31.52 0 59.968-12.992 80.48-33.888l-0.064-0.064 266.912-266.88c53.632 28.512 114.752 44.8 179.744 44.8 212.064 0 384-171.936 384-384s-171.936-384-384-384zM153.44 950.304c-10.304 10.688-24.576 17.376-40.512 17.376-31.2 0-56.48-25.248-56.48-56.448 0-15.936 6.72-30.176 17.376-40.512l-0.288-0.256 258.112-258.112c22.56 30.432 49.44 57.312 79.808 79.936l-258.016 258.016zM640 704.192c-176.704 0-320-143.328-320-320 0-176.704 143.296-320 320-320 176.672 0 320 143.296 320 320 0 176.672-143.328 320-320 320zM640 160.16c8.8 0 16 7.168 16 16s-7.2 16-16 16c-106.048 0-192 85.984-192 192 0 8.832-7.168 16-16 16s-16-7.168-16-16c0-123.712 100.256-224 224-224z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1542b24d6039d50a682dda3087ccb587.svg";
export { ForwardRef as ReactComponent };